export const compKindOptions = [
  {
    value: "010",
    label: "外商独资/外企办事处",
  },
  {
    value: "020",
    label: "中外合营(合资/合作)",
  },
  {
    value: "030",
    label: "私营/民营企业",
  },
  {
    value: "040",
    label: "国有企业",
  },
  {
    value: "050",
    label: "国内上市公司",
  },
  {
    value: "060",
    label: "政府机关/非盈利机构",
  },
  {
    value: "070",
    label: "事业单位",
  },
  {
    value: "999",
    label: "其它",
  },
];
export const compScaleOptions = [
  {
    value: "010",
    label: "1-49人",
  },
  {
    value: "020",
    label: "50-99人",
  },
  {
    value: "030",
    label: "100-499人",
  },
  {
    value: "040",
    label: "500-999人",
  },
  {
    value: "050",
    label: "1000-2000人",
  },
  {
    value: "060",
    label: "2000-5000人",
  },
  {
    value: "070",
    label: "5000-10000人",
  },
  {
    value: "080",
    label: "10000人以上",
  },
];
export const filterComps = [
  {
    name:'热门企业',
    comps:[
      9864639,
      8300381,
      8871840,
      7990821,
      8657593,
      9604726,
      13278567,
      13743511,
      7746541,
      13749165,
      12379127,
      8097359,
      7987816,
      8160300,
      10150065
    ]
  },
  {
    name:'造纸及纸品加工',
    comps:[
      12794489,
      12190513,
      7227656 ,
      13212067,
    ]
  },
  {
    name:'新一代信息技术',
    comps:[
      9204119,
      8646113,
      7990821,
      8439651,
      8135377,
      9556149,
      9402237,
      10116639,
      8643461,
      8053663,
      9290668,
      7941752,
      8004525,
      13601723,
      8385829,
      12183789,
      8575258,
      8373646,
      7973899,
      9989873,
      13706989,
      9653861,
      9877955,
      8542141,
      7949809,
      8187357,
      8778795,
      12262831,
      12358309,
      9797267,
      8881347,
      7949702,
      8686211,
      10126541,
      9220057,
      9172924,
      8068460,
      8195960,
      13276885,
      12573611,
      13018317
    ]
  },
  {
    name:'新能源',
    comps:[
      10150065,
      12143231,
      8301135,
      9538814,
      9324405,
      8292591,
      12773211,
      12646513,
      13632413,
      9304429,
      8160300
    ]
  },
  {
    name:'新材料',
    comps:[
      9306052,
      8451486,
      9660061,
      9579368,
      8733440,
      8238266,
      12977905,
      9864639,
      9637220,
      9339113,
      9839627,
      8072669,
      8462184,
      13748275,
      12572537,
      9655077,
      12320015,
      12872179,
      12379127
    ]
  },
  {
    name:'生物医药',
    comps:[
      7915371,
      8386455,
      8871840,
      8184708,
      8768115,
      12995039,
      13749675,
      8151233,
      13749623,
      12802859,
      12985647,
      13135161
    ]
  },
  {
    name:'机械加工与制造', 
    comps:[
      12204585,
      9985261,
      13095845,
      10167535,
      12675991,
      13500961,
      13422681,
      13066817,
      13431665,
      13585183,
      8010569,
      13072871,
      13586119,
      12178365,
      9808321,
      12204585
    ]
  },
  {
    name:'化工', 
    comps:[
      10144963,
      9851859,
      8879134,
      8017152,
      7922374,
      12246719,
      9367539,
      9187745,
      7971862,
      8565231,
      12392023,
      7953120,
      8069434,
      12359313,
      7940696,
      9384005,
      8237665,
      9358572,
      8099536,
      13461901,
      8443194,
      10284563,
      13715039,
      8013517,
      13566519,
      7935032,
      10084493,
      7987816,
      13278567,
      9349522,
      9794701,
      1218377,
      8099536,
      8063426,
      8069434
    ]
  },
  {
    name:'航空航天', 
    comps:[
      8960615,
      8300381,
      9360057,
      12974889,
      10282295,
      7977340,
      8657593,
      9124846,
      3472706
    ]
  },
  {
    name:'服务业', 
    comps:[
      9279304,
      9826975,
      7939438,
      9383771,
      9177236,
      9678626,
      10153889,
      9371118,
      12546851,
      13187699,
      12382911,
      3478214,
      9728584,
      12177367,
      12772027,
      8392477,
      10133743,
      8389743,
      9707654,
      7948248,
      9789569,
      10275387,
      9457062,
      13739307,
      9388874,
      12603893,
      9974387,
      12853511,
      9489551,
      8126129,
      8125822,
      9440193,
      12342897,
      8949187,
      12878795,
      8675409,
      8407347,
      9842637,
      7919444,
      10137147,
      9411459,
      12162965,
      13359127,
      8423523,
      9500233,
      12525423,
      13497283,
      12319075,
      7940582,
      9611371,
      9915501,
      8125785,
      9214101,
      13749145,
      13294055,
      12744439,
      8009062,
      8182899,
      10274191,
      12910055,
      12615207,
      8276359,
      8150154,
      9747859,
      8296476,
      7862299,
      10233617,
      10172285,
      7924487,
      9649474,
      9342412,
      9727442,
      10063215,
      8578588,
      10166089,
      10259967,
      9921943,
      8031466,
      10207261,
      8104799,
      12884187,
      9564287,
      13024013,
      12217783,
      13381043,
      12383303,
      13073935,
      13187699,
      9841041,
      13181207,
      13718641
    ]
  },
  {
    name:'电力电气', 
    comps:[
      12147857,
      13748307,
      8196301,
      9219786,
      13277599,
      10221837,
      8148263,
      13611701,
      13274329,
      8843374,
      10257199,
      7964402,
      12375715,
      8690829,
      12142255,
      7746541,
      9432374,
      8097359,
      8009041,
      9322019,
      9358605,
      9889989,
      8002041,
      13277175,
      13130197,
      8004541,
      8196300,
      13749165,
      10166529,
      9172684,
      12211629,
      13143499,
      9985261
    ]
  },
  {
    name:'车船配套/汽车零部件',
    comps:[
      10003673,
      9840669,
      13671017,
      7882887,
      7916262,
      9287809,
      13552491,
      12955653,
      9806379,
      8291009,
      8123238,
      10274239,
      10211027,
      8848995,
      12678651,
      9604726,
      9431217,
      10065193,
      7973034,
      8002023,
      8921143,
      7916262,
      10003673
    ]
  },
  {
    name:'其他',
    comps:[
      8391335,
      9730750,
      9743769,
      12564851,
      12970785,
      8214046,
      12386161,
      12684369,
      13614323,
      9323351,
      9403024,
      12754503,
      8088164,
      7877670,
      9297560,
      9655077,
      10172285,
      8862262,
      13000381,
      9986183,
      13092225,
      13181207,
      7965064,
      13749085,
      8002162,
      8412685,
      13353411,
      13623441,
      8488654,
      12565575,
      12944109,
      12582689,
      12511903,
      12544611,
      9487992,
      8931891,
      7984988,
      9620896,
      10049431,
      13005361,
      7987056,
      9316087,
      9400955,
      7922281,
      12188187,
      12551739,
      12370959,
      9723861,
      9557615,
      9341792,
      8414835,
      8034492,
      8974450,
      12183791,
      13636631,
      9673081,
      10236779,
      7889920,
      13202313,
      7980240,
      9818441,
      8468372,
      7965060,
      9417573,
      10195619,
      13134661,
      8002278,
      8671314,
      13348569,
      8978532,
      8015910,
      13233299,
      8271901,
      2623757,
      9923609,
      13313855
    ]
  },
]